import { render, staticRenderFns } from "./MyCampaignsTabs.vue?vue&type=template&id=fc79f28c&scoped=true"
import script from "./MyCampaignsTabs.vue?vue&type=script&lang=ts"
export * from "./MyCampaignsTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc79f28c",
  null
  
)

export default component.exports